import { loadApplyFormData } from "./applyFormStorage";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8001";

const resolveCustomerIdentity = (storedData) => {
  const auth = storedData.auth && typeof storedData.auth === "object" ? storedData.auth : {};
  const preliminary = storedData.preliminary && typeof storedData.preliminary === "object" ? storedData.preliminary : {};

  return {
    customerId: auth.customerId ?? null,
    email: auth.email || preliminary.email || "",
  };
};

export const saveCustomerProfileStep = async (step, data) => {
  const storedData = loadApplyFormData();
  const { customerId, email } = resolveCustomerIdentity(storedData);

  const response = await fetch(`${API_BASE_URL}/api/customer/profile/save/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      step,
      data,
      customerId,
      email,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to save your profile right now. Please try again.");
  }

  return payload;
};

export const fetchCustomerProfile = async (identity = {}) => {
  const storedData = loadApplyFormData();
  const fallbackIdentity = resolveCustomerIdentity(storedData);

  const customerId = identity.customerId ?? fallbackIdentity.customerId;
  const email = identity.email ?? fallbackIdentity.email;

  const response = await fetch(`${API_BASE_URL}/api/customer/profile/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      customerId,
      email,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to load your profile right now. Please try again.");
  }

  return payload;
};

export const changeCustomerEmail = async ({ newEmail, currentPassword, identity = {} }) => {
  const storedData = loadApplyFormData();
  const fallbackIdentity = resolveCustomerIdentity(storedData);

  const customerId = identity.customerId ?? fallbackIdentity.customerId;
  const email = identity.email ?? fallbackIdentity.email;

  const response = await fetch(`${API_BASE_URL}/api/customer/change-email/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      customerId,
      email,
      newEmail,
      currentPassword,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to change email right now. Please try again.");
  }

  return payload;
};

export const resetCustomerPassword = async ({ currentPassword, newPassword, confirmPassword, identity = {} }) => {
  const storedData = loadApplyFormData();
  const fallbackIdentity = resolveCustomerIdentity(storedData);

  const customerId = identity.customerId ?? fallbackIdentity.customerId;
  const email = identity.email ?? fallbackIdentity.email;

  const response = await fetch(`${API_BASE_URL}/api/customer/reset-password/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      customerId,
      email,
      currentPassword,
      newPassword,
      confirmPassword,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to reset password right now. Please try again.");
  }

  return payload;
};

export const requestCustomerPasswordReset = async ({ email }) => {
  const response = await fetch(`${API_BASE_URL}/api/customer/forgot-password/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      email,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to start password reset right now. Please try again.");
  }

  return payload;
};

export const confirmCustomerPasswordReset = async ({ uid, token, newPassword, confirmPassword }) => {
  const response = await fetch(`${API_BASE_URL}/api/customer/forgot-password/confirm/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-App": "swiftcredit",
    },
    body: JSON.stringify({
      uid,
      token,
      newPassword,
      confirmPassword,
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to reset password right now. Please try again.");
  }

  return payload;
};
